/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect } from 'react';
import { DatePicker, Pagination, Select } from 'antd';
import type { Dayjs } from 'dayjs';
import { useDebounce } from 'use-debounce';
import dayjs from 'dayjs';
import './style.scss';
import { AdminApi } from '../../api/Admin';
import LoadingTable from '../../components/LoadingTable';
import { formatTimestamp, truncateText } from '../Utils';
import { Noti } from '../../components/Noti/toast';

const { RangePicker } = DatePicker;

const UsersPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null] | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('DESC');
    const [totalItems, setTotalItems] = useState<any>(0);
    const [users, setUsers] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [debouncedSearchTerm] = useDebounce(searchTerm, 500);

    const getListUsers = async () => {
        setLoading(true);
        try {
            let params = {
                search: debouncedSearchTerm,
                page: currentPage,
                limit: pageSize,
                sortOrder: sortOrder
            };
            const res = await AdminApi.GetListUsers(params);
            if (res?.status === 200) {
                setUsers(res?.data?.data);
                setTotalItems(res?.data?.total);
            } else {
                setUsers([]);
                setTotalItems(0);
            }
        } catch (err: any) {
            setUsers([]);
            setTotalItems(0);
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getListUsers();
    }, [debouncedSearchTerm, currentPage, sortOrder]);

    React.useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchTerm, sortOrder]);

    async function handleCopy(id: any) {
        try {
            await navigator.clipboard.writeText(id);
            Noti('success', `Copied`, 3000)
        } catch (err) {
            Noti('error', `Failed to copy!`, 3000)
        }
    }

    return (
        <div className="page active">
            <h1 className="users-page-title">User Management</h1>
            <div className="content-card">
                <div className="users-filters">
                    <input
                        type="search"
                        placeholder="Search by email..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className="form-input search-input"
                    />
                    {/* <div className="date-range-filter">
                        <label>Sync Date:</label>
                        <RangePicker
                            value={dateRange}
                            onChange={(dates) => setDateRange(dates)}
                            format="YYYY-MM-DD"
                            className="date-range-picker"
                        />
                    </div> */}
                    <div className="status-filter">
                        <label htmlFor="sort-order-filter">Sort Order:</label>
                        <Select
                            id="sort-order-filter"
                            value={sortOrder}
                            onChange={(value) => setSortOrder(value)}
                            className="sort-order-select"
                            style={{ width: '100%' }}
                            options={[
                                { value: 'ASC', label: 'Ascending' },
                                { value: 'DESC', label: 'Descending' },
                            ]}
                        />
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>User Email</th>
                                <th>Partner User ID</th>
                                <th>PWC User ID</th>
                                <th>Sync Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <>
                                    <tr>
                                        <td colSpan={4}>
                                            <div className="box-nodata">
                                                <LoadingTable />
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <>
                                    {users.length > 0 ? users.map((user: any, index: any) => (
                                        <tr key={user.pwc_user_id}>
                                            <td data-label="User Email">
                                                {user.email ? (
                                                    <div className='row-copy'>
                                                        <span>{truncateText(user.email)}</span>
                                                        <img
                                                            onClick={() => handleCopy(user.email)}
                                                            className='icon-copy'
                                                            src="/images/copy.png"
                                                            alt=""
                                                        />
                                                    </div>
                                                ) : ('N/A')}
                                            </td>
                                            <td className='row-copy' data-label="Partner User ID">
                                                {user.partnerUserId ? (
                                                    <div className='row-copy'>
                                                        <span>{user.partnerUserId}</span>
                                                        <img
                                                            onClick={() => handleCopy(user.partnerUserId)}
                                                            className='icon-copy'
                                                            src="/images/copy.png"
                                                            alt=""
                                                        />
                                                    </div>
                                                ) : ('N/A')}
                                            </td>

                                            <td data-label="PWC User ID">
                                                {user.pwc_user_id ? (
                                                    <div className='row-copy'>
                                                        <span>{truncateText(user.pwc_user_id)}</span>
                                                        <img
                                                            onClick={() => handleCopy(user.pwc_user_id)}
                                                            className='icon-copy'
                                                            src="/images/copy.png"
                                                            alt=""
                                                        />
                                                    </div>
                                                ) : ('N/A')}
                                            </td>
                                            <td data-label="Sync Date">
                                                {formatTimestamp(user.updatedAt)}
                                            </td>
                                        </tr>
                                    )) : <tr>
                                        <td colSpan={4} className="no-data">No users found.</td>
                                    </tr>}
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
                {users.length > 0 && (
                    <div className="pagination-wrapper">
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalItems}
                            // showSizeChanger
                            // showQuickJumper
                            // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} users`}
                            onChange={(page, size) => {
                                setCurrentPage(page);
                                // setPageSize(size);
                            }}
                        // onShowSizeChange={(current, size) => {
                        //     setCurrentPage(1);
                        //     setPageSize(size);
                        // }}
                        // pageSizeOptions={['5', '10', '20', '50', '100']}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default UsersPage;